<template>
    <v-dialog v-model="dialog" :max-width="800" persistent>
        <v-card title="Contact Us" role="dialog">
            <div class="d-flex align-center py-2 pl-4 pr-3 primary white--text">
                <v-icon left color="white">mdi-email</v-icon>
                <div class="title">Contact Us</div>
                <v-spacer></v-spacer>
                <v-btn icon aria-label="close" @click="cancel()">
                    <v-icon color="white">mdi-close</v-icon>
                </v-btn>
            </div>
            <v-card-text class="body-1 pa-5">
                <div v-if="standard">
                    <div class="primary--text">
                        <em>In reference to:</em>
                    </div>
                    <v-row no-gutters>
                        <v-col>{{ standard.sdo }}</v-col>
                        <v-col cols="auto" class="text-right">{{ standard.standardId }}</v-col>
                    </v-row>
                    <div class="font-weight-bold">{{ standard.title }}</div>
                </div>
                <ContactForm ref="contactForm" :standard="standard" v-on:complete="complete"></ContactForm>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    import ContactForm from '@/components/ContactForm';

    export default {
        components: { ContactForm },
        data: () => ({
            dialog: false,
            resolve: null,
            reject: null,
            standard: null
        }),
        methods: {
            show(standard) {
                this.dialog = true;
                this.standard = standard;
                this.$nextTick(() => {
                    this.$refs.contactForm.reset();
                });
                return new Promise((resolve, reject) => {
                    this.resolve = resolve;
                    this.reject = reject;
                });
            },
            complete(success) {
                if (success) {
                    this.resolve(true);
                    this.dialog = false;
                }
            },
            cancel() {
                this.resolve(false);
                this.dialog = false;
            }
        }
    };
</script>
